"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.number.constructor");
var _physical_card = require("@/api/community/physical_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PhysicalCardDetailPane',
  props: {
    crId: {
      type: Number,
      default: null
    },
    cardTypeName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      total: 0,
      tableData: [],
      physicalCardOptions: [],
      listQuery: {
        crId: null,
        page: 1,
        limit: 20
      }
    };
  },
  watch: {
    crId: {
      immediate: true,
      handler: function handler(val) {
        if (val != null) {
          this.listQuery.crId = val;
        }
      }
    }
  },
  created: function created() {
    this.loadPhysicalCardOptions();
    this.search();
  },
  methods: {
    loadPhysicalCardOptions: function loadPhysicalCardOptions() {
      var _this = this;
      (0, _physical_card.getPhysicalCardPage)({
        page: 1,
        limit: 999
      }).then(function (res) {
        _this.physicalCardOptions = res.records || [];
      });
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      this.loading = true;
      (0, _physical_card.getPhysicalCardItemPage)(this.listQuery).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.total = res.total || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      var d = new Date(val);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }
  }
};